module.exports = __webpack_public_path__ + "img/lap.48ca074b.png";